<template>
  <div>
    <!-- 顶部信息区域 -->
    <div class="info-container">
      <el-row :gutter="15">
        <el-col :span="8" v-for="item in list" :key="item.value">
          <el-tag type="primary" class="info-tag">
            <span>{{ item.label }}</span>
            <div class="tag-desc">{{ item.tip }}</div>
          </el-tag>
        </el-col>
      </el-row>
    </div>

    <!-- 查询区域 -->
    <el-form :inline="true" :model="formData" class="search-container">
        <el-form-item >
             <custom-input label="项目名称">
                <el-input style="width: 200px" v-model="formData.search" placeholder="请输入项目名称"></el-input>
             </custom-input>
        </el-form-item>
        <el-form-item >
            <custom-input label="素材数量">
              <!-- 整数 -->
                <el-input-number style="width: 150px" v-model="formData.num"  :min="1" :max="1000" step-strictly :step="1" placeholder="0"></el-input-number>
            </custom-input>
        </el-form-item>
        <el-form-item>
            <el-button type="primary" @click="handleSearch">获取 
                <el-tooltip effect="dark" content="素材选用逻辑:未使用>已使用，已使用素材按照投放情况进行打分，通过分值排序使用。" placement="top">
                    <i class="el-icon-question"></i>
                </el-tooltip>
            </el-button>
        </el-form-item>
       <el-form-item v-if="isVideo">
            <el-checkbox v-model="formData.autoGenerateCover">自动生成封面</el-checkbox>
        </el-form-item>
    </el-form>
    <el-alert
        title=""
        :type="materialTableData.length >0 ? 'success' : 'error'"
        :show-icon="false"
        :closable="false"
        v-if="showTip"
        class="mb10"
    >
        <p v-if="materialTableData.length == formData.num">获取完成:未使用【{{statusMap[0] || 0}}】个，已使用【{{statusMap[1] || 0}}】个。</p>
        <p v-else-if="materialTableData.length>0">获取完成:工单素材不满足需要的数量，未使用【{{statusMap[0] || 0}}】个，已使用【{{statusMap[1] || 0}}】个。</p>
        <p v-else>无匹配的素材</p>
    </el-alert>
    <!-- 表格区域 -->
    <div  v-loading="loading">
      <el-table
        :data="tableData"
        border
        stripe
        :header-cell-style="{background:'#e8eaec',color:'#333'}"
        width="100%"
        max-height="300px"
      >
        <el-table-column prop="material" label="素材" width="200">
          <template slot-scope="scope">
            <material-view :file="scope.row" :type="scope.row.material_type == 1 ?'image':'video'" />
          </template>
        </el-table-column>
        <el-table-column prop="material_md5" label="素材MD5" show-overflow-tooltip width="250"></el-table-column>
        <el-table-column prop="is_used_text" label="使用状态" />
        <el-table-column prop="overall_scoring" label="评分" ></el-table-column>
        <el-table-column prop="rating" label="评级" />
        <el-table-column  label="操作" width="70" align="center">
          <template slot-scope="scope">
            <el-button type="text"  @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        class="tac mt10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="materialTableData.length"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        :current-page="pageNum"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
      />
    </div>
    <!-- 底部按钮区域 -->
    <div  class="tac mt20">
      <el-button @click="$emit('close')">取消</el-button>
      <el-button type="primary" :disabled="submitLoading || materialTableData.length == 0" @click="handleSubmit">应用</el-button>
    </div>
  </div>
</template>

<script>
import API from '@/api/marketManage/miBatch';
import MaterialView from './materialView.vue'
export default {
  name: 'SelectAiMaterialModal',
  props: [ 'cbs', 'list', 'params', 'appName', 'isVideo' ],
  components: {
    MaterialView
  },
  data() {
    return {
      formData: {
        search: this.appName,
        num: 10,
        autoGenerateCover: this.isVideo,
      },
      materialTableData: [],
      loading: false,
      pageSize: 10,
      pageNum: 1,
      total: 0,
      is_used_num: 0,
      no_used_num: 0,
      submitLoading: false,
      showTip: false,
    }
  },
  computed: {
    // 分页materialTableData
    tableData() {
      const start = (this.pageNum - 1) * this.pageSize;
      const end = start + this.pageSize;
      return this.materialTableData.slice(start, end);
    },
    statusMap(){
      return this.materialTableData.reduce((pre, cur) => {
        pre[cur.is_used] = (pre[cur.is_used] || 0) + 1;
        return pre;
      }, {})
    }
  },
  methods: {
    // 分页切换
    handleCurrentChange(pageNum) {
      this.pageNum = pageNum;
    },
    // 每页条数切换
    handleSizeChange(pageSize) {
      this.pageNum = 1;
      this.pageSize = pageSize;
    },
    async handleSearch() {
      try {
        this.loading = true;
        const { data } = await API.getIntelligentMaterialList({
          ...this.params,
          search: this.formData.search,
          num: this.formData.num,
        });
        this.materialTableData = data.list;
        this.is_used_num = data.is_used_num;
        this.no_used_num= data.no_used_num;
        this.total = data.list?.length || 0;
        this.pageNum = 1;
      } catch (error) {
        console.log(error);
        this.$message.error(error.info)
      }finally{
        this.showTip = true;
        this.loading = false;
      }
      // 调用接口获取素材列表
    },
    async handleSubmit() {
        try {
          this.submitLoading = true;
          await this.cbs.onSubmit(this.materialTableData, this.formData.autoGenerateCover)
        } catch (error) {
          console.log(error, 'error');
        }finally{
          this.submitLoading = false;
        }
    },
    handleDelete(row) {
        this.$confirm('确定删除该素材吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            // 调用删除接口
            this.materialTableData = this.materialTableData.filter(item => item !== row);
            if(this.tableData.length === 1 && this.pageNum > 1) {
              this.pageNum--;
            }
        }).catch(() => {
            // 取消删除
        });
    },
    // 根据评级获取标签类型
    getRatingType(rating) {
      switch (rating) {
        case 'S级':
          return 'danger';
        case 'A级':
          return 'primary';
        default:
          return 'default';
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.info-container {
  margin-bottom: 20px;
}

.info-tag {
  width: 100%;
  height: 70px;
  font-size: 14px;
  text-align: center;
  padding-top: 10px;
  span {
    color: #666;
    font-weight: bold;
    display: inline-block;
    // 文字超出部分省略号
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.tag-desc {
  text-align: center;
  color: #606266;
  font-size: 14px;
}

.search-container {
  border-radius: 4px;
}


</style>